import { IRadiobuttonItem } from "~app/common/components/radiobuttongroup/radiobutton/IRadiobuttonItem";

export type CertifikatDto = {
    id?: number;
    certifikatsnummer: string;
    certifikatstyp: string;
    antalKontrakt: number;
    agare: string;
    sveaskog: boolean;
    aktiv: boolean;
    giltigTom: Date;
    canDelete: boolean;
};

export const defaultCertifikat: CertifikatDto = {
    certifikatsnummer: "",
    certifikatstyp: "FSC",
    antalKontrakt: 0,
    agare: "",
    sveaskog: false,
    aktiv: false,
    giltigTom: undefined,
    canDelete: false
};

export type CertifikatRadioButtonOption = "ja" | "nej" | "alla";

export type CertifikatSearchFilterDto = {
    certifikatsnummer: string;
    certifikatstyp: string[];
    agare: string;
    sveaskog?: boolean;
    aktiv?: boolean;
    certifikatFrom: Date;
    certifikatTom: Date;
};

export type CertifikatKontraktDto = {
    avtalId: number;
    kontraktId: number;
    kontraktnummer: string;
    benamning: string;
    affarsform: string;
    status: string;
    ansvarigVirkeskopare: string;
    kontraktGiltigtFrom: string;
    kontraktGiltigtTom: string;
    skickadTillVacs: string;
    vacsAvraknatDatum: string;
    aoBeteckningar: string;
    slutrapporteradDatum: string;
    transportAvslutadDatum: string;
    produktionGodkandDatum: string;
    skotningAvslutadDatum: string;
};

export type CertifikatSearchFilter = Omit<CertifikatSearchFilterDto, "sveaskog" | "aktiv"> & {
    sveaskog: CertifikatRadioButtonOption;
    aktiv: CertifikatRadioButtonOption;
    certifikatFrom: Date;
    certifikatTom: Date;
};

type RadioButtonItem = Omit<IRadiobuttonItem, "key"> & { key: CertifikatRadioButtonOption };

export const certifikatRadioButtonItems: RadioButtonItem[] = [
    {
        key: "ja",
        value: "Ja"
    },
    {
        key: "nej",
        value: "Nej"
    },
    {
        key: "alla",
        value: "Alla"
    }
];
